import { connect } from 'react-redux';
import ForgotEmail from '../../../components/ForgotPage/ForgotEmail';

export default connect()(ForgotEmail);
